import React from "react";
import Checkbox from "../Category/Filter/Common/Checkbox";

const FeaturedDropdown = ({ title, dropdown, price }) => {
  return (
    <div className="grid w-full grid-cols-4">
      <Checkbox
        label={title}
        className="col-span-2 justify-self-start"
        labelClassName="text-xl opacity-50"
      />
      {dropdown && (
        <select className="justify-self-center rounded border border-inputBorder bg-transparent p-1 font-pop text-xl text-black opacity-50">
          <option>30 Days</option>
          <option>60 Days</option>
          <option>70 Days</option>
          <option>100 Days</option>
        </select>
      )}
      {price && (
        <span className="justify-self-end font-pop text-xl text-black opacity-50">
          R{price}
        </span>
      )}
    </div>
  );
};

export default FeaturedDropdown;
